export function JsBp(){

    return(

        <>
        <h1 className="html_gfg_heading">These are the <strong style={{textDecoration : 'underline', color : 'blue'}}>Top 10 </strong> recommended Main Projects that you can Do with this Project Ideas  </h1>


        <h4 className="des_bp_html">

        1. Do with your own<strong> Main </strong>knowing Concepts. <br/>
        2. Aks GPT to your doubt Clarification.  <br/>
        3. Enough projects to do this which we are recommended.
        </h4>

        {/* <-----------------------------------------1------------------------------------------*/}
        <div className="container_html_bp_links">

        <p className="vid">Project 1: To-Do List App



        {/* <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius :        '8px'}}        onClick={() => window.open(val1, "_blank")}>  Click Me </button>   */}

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------2------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid">  Project 2: Simple Calculator

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------3------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 3: Digital Clock

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------4------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 4: Color Picker

        </p>
        <p>
        </p>

        </div> 


        {/* <-----------------------------------------5------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 5: Guess the Number Game

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------6------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 6:  Weather App (Using API)

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------7------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 7: Image Slider

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------8------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 8: Quiz App (Simple Web app )

        </p>
        <p>
        </p>

        </div>

        {/* <-----------------------------------------9------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 9: Form Validation

        </p>
        <p>
        </p>

        </div>


        {/* <-----------------------------------------10------------------------------------------*/}

        <div className="container_html_bp_links">

        <p className="vid"> Project 10: Tip Calculator


        </p>
        <p>
        </p>

        </div>

        </>
    )
}

export default JsBp; 